import { Role } from "@features/invitations/types/roleResponse";
import { MAIN_OFFICE_DEPARTMENT_ID } from "@features/department/constants/departmentIds";

/** @deprecated Prefer MAIN_OFFICE_DEPARTMENT_ID from department constants. */
export { MAIN_OFFICE_DEPARTMENT_ID };

/** @deprecated Prefer entity scope constants; kept as aliases for invite call sites. */
export {
    ENTITY_SCOPE_SECTION_BG as INVITE_SCOPE_SECTION_BG,
    ENTITY_SCOPE_SECTION_HEADERS as INVITE_SCOPE_SECTION_HEADERS,
    ENTITY_SCOPE_SECTION_DIVIDER_CLASS as INVITE_SCOPE_SECTION_DIVIDER_CLASS,
    ENTITY_SCOPE_PICKER_VARIANT_CLASS as INVITE_SCOPE_PICKER_VARIANT_CLASS,
    formatEntityScopeLabel as formatInviteEntityLabel,
    formatChurchDistrictSublabel,
} from "@features/entity/constants/entityScopePicker";

/**
 * Roles allowed for the selected department (mirrors API validateRoleDepartmentRequired).
 * Main Office (id 1): org roles only (department_required = false).
 * Any other department: dept roles only (department_required = true).
 */
export function rolesForDepartment(roles: Role[], departmentId: number): Role[] {
    if (!departmentId || departmentId <= 0) return roles;
    const needsDeptRole = departmentId !== MAIN_OFFICE_DEPARTMENT_ID;
    return roles.filter((r) => Boolean(r.department_required) === needsDeptRole);
}

/**
 * Whether a selected role remains valid for the given department.
 */
export function isRoleValidForDepartment(role: Role | undefined, departmentId: number): boolean {
    if (!role || !departmentId || departmentId <= 0) return false;
    const needsDeptRole = departmentId !== MAIN_OFFICE_DEPARTMENT_ID;
    return Boolean(role.department_required) === needsDeptRole;
}
